import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import * as S from "./SidebarTopPatients.style";

// components
import FilterPrograms from "../../../shared/filterPrograms";
import ZaiaToggle from "../../../../zaiaComponents/zaiaToggle";
import FilterInputText from "../../../shared/filterInputText";
import Modal from "../../../../../utils/modal";
import CreateChatGroupModal from "../../../chat/components/createChatGroupModal";

function SidebarTopPatients({
  title,
  quantity,
  processIds,
  setProcessIds,
  setInputFilter,
  typeFilter,
  filterText,
  filterPlaceholder,
  activeFilterProcess = true,
  component,
}) {
  const [t] = useTranslation("global");
  const [activeTab, setActiveTab] = useState(1);
  const [activeCreateChatGroupModal, setActiveCreateChatGroupModal] = useState(false);
  const tabs = [
    { id: 1, name: t("patients.patientList.programs") },
    { id: 2, name: t("patients.patientList.general") },
  ];

  return (
    <S.SidebarTopPatients>
      <Modal open={activeCreateChatGroupModal}>
        <CreateChatGroupModal
          setActiveCreateChatGroupModal={setActiveCreateChatGroupModal}
        />
      </Modal>
      {/* <S.ToggleContainer>
        <ZaiaToggle
          color="var(--no-notification-color)"
          tabs={tabs}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
      </S.ToggleContainer> */}
      {activeFilterProcess ? (
        <S.FilterContainer>
          <FilterPrograms
            processIds={processIds}
            setProcessIds={setProcessIds}
          />
          <div className="button-container">
            <button
              className="button-create-chat-group"
              onClick={() => setActiveCreateChatGroupModal(true )}
            >
              {t("chat.createChatGroup.createGroup")}
            </button>
          </div>
        </S.FilterContainer>
      ) : null}
      <S.InputContainer>
        <FilterInputText
          filterBy={filterText}
          type={"text"}
          placeholder={filterPlaceholder}
          setInputFilter={setInputFilter}
        />
      </S.InputContainer>
      <S.TitleContainer>
        <h3>{title}</h3>
        <span>({quantity})</span>
      </S.TitleContainer>
    </S.SidebarTopPatients>
  );
}

export default SidebarTopPatients;
